import {
  Box,
  ClickAwayListener,
  Popper,
  Typography,
  useTheme,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import BeachAccessIcon from '@mui/icons-material/BeachAccess';
import MoneyOffCsredIcon from '@mui/icons-material/MoneyOffCsred';
import SickIcon from '@mui/icons-material/Sick';
import { tokens } from '../../../global/theme/tokens';
import { secondsToHours } from './workTimeReportUtils';

const AbsencePopper = ({ open, anchorEl, onClose, userOverview }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);
  const { t } = useTranslation();

  if (!userOverview) return null;

  const rows = [
    {
      key: 'payed',
      Icon: BeachAccessIcon,
      label: t('Paid vacation'),
      seconds: userOverview.payedVacationInSeconds || 0,
      color: colors.success,
    },
    {
      key: 'unpayed',
      Icon: MoneyOffCsredIcon,
      label: t('Unpaid vacation'),
      seconds: userOverview.unpayedVacationInSeconds || 0,
      color: colors.warning,
    },
    {
      key: 'sick',
      Icon: SickIcon,
      label: t('Sick'),
      seconds: userOverview.sickTimeInSeconds || 0,
      color: colors.error,
    },
  ];

  return (
    <Popper
      open={Boolean(open)}
      anchorEl={anchorEl}
      placement="bottom-start"
      sx={{ zIndex: 9999, paddingTop: '6px' }}
    >
      <ClickAwayListener onClickAway={onClose}>
        <Box
          className="rounded-lg backdrop-blur-lg p-3 flex flex-col gap-2 min-w-[240px]"
          sx={{
            bgcolor: colors.cardSolid,
            boxShadow: 3,
          }}
        >
          {rows.map(({ key, Icon, label, seconds, color }) => (
            <Box key={key} className="flex items-center gap-2">
              <Icon sx={{ color, fontSize: 18 }} />
              <Typography
                variant="body2"
                sx={{ flex: 1, opacity: seconds === 0 ? 0.5 : 1 }}
              >
                {label}
              </Typography>
              <Typography variant="body2" sx={{ fontWeight: 600 }}>
                {secondsToHours(seconds)} h
              </Typography>
            </Box>
          ))}
        </Box>
      </ClickAwayListener>
    </Popper>
  );
};

export default AbsencePopper;
